module.exports = __webpack_public_path__ + "static/media/21ECLAC23.e7ffe605.jpg";